import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";

@Component
export class QualificationDetailsContentBase extends Vue {
    @Prop()
    id!: string;

    dataLoaded = false;
}
